'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = ['M98 272.2c-7 38-1.8 73.2 18.5 100.7l220.5-220.4 22.6 22.6-48.9 48.9 120.7 0c5.7-15.7 11-31.9 15.7-48.3 14.5-50.4 23.6-100.5 28.8-139.5-39 5.2-89.1 14.3-139.5 28.8-66 19-128.3 46-168.6 82l-7.7 7.3c-29.6 29.6-53.9 73.7-62 118zm41.1 123.3c27.5 20.3 62.7 25.5 100.7 18.5 44.3-8.2 88.3-32.4 118-62l-175.1 0-43.6 43.5zM214.6 320l169.3 0c12.9-18.8 24.4-40.5 34.6-64l-139.9 0-64 64z', 'M512 0c-6.9 83.7-40.5 283.5-131.6 374.6l-6.6 6.3c-66.1 61-182.3 97.2-257.6 37.4L25.6 509 3 486.4 93.6 395.7c-59.8-75.3-23.5-191.5 37.4-257.5l6.3-6.6C228.5 40.5 428.3 6.9 512 0zM182.6 352l-43.6 43.5c27.5 20.3 62.7 25.5 100.7 18.5 44.3-8.2 88.3-32.4 118-62l-175.1 0zM475.8 36.1c-39 5.2-89.1 14.3-139.5 28.8-66 19-128.3 46-168.6 82l-7.7 7.3c-29.6 29.6-53.9 73.7-62 118-7 38-1.8 73.2 18.5 100.7l220.5-220.4 22.6 22.6-48.9 48.9 120.7 0c5.7-15.7 11-31.9 15.7-48.3 14.5-50.4 23.6-100.5 28.8-139.5zM278.6 256l-64 64 169.3 0c12.9-18.8 24.4-40.5 34.6-64l-139.9 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;